export class FeatureIntroductionVersionPresenter {
    constructor(platform) {
        this.iOS = platform.iOS
        this.android = platform.android
    }
}
